import Reveal from "./Reveal";
import { Check } from "lucide-react";
import { WHY_POINTS } from "@/data/content";

const WhyChooseUs = () => (
  <section id="why" data-testid="why-section" className="py-20 md:py-28 bg-sky-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal className="order-2 lg:order-1">
        <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-primary/10 border border-border/60">
          <img src="/assets/why-choose.png" alt="On Time Couriers professional service" className="w-full h-auto object-cover" />
        </div>
      </Reveal>

      <div className="order-1 lg:order-2">
        <Reveal>
          <span className="text-sm font-bold uppercase tracking-wider text-primary">Why Choose Us</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-foreground leading-tight">
            Trusted by Businesses <span className="text-primary">Across the Region</span>
          </h2>
          <p className="mt-4 text-muted-foreground text-base md:text-lg leading-relaxed">
            On-Time Couriers isn't just a name — it's a promise. We combine cutting-edge logistics
            technology with old-fashioned reliability to ensure every delivery arrives safely, on
            time, every time.
          </p>
        </Reveal>

        <div className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-4">
          {WHY_POINTS.map((p, i) => (
            <Reveal key={p.text} delay={i * 0.05}>
              <div className="flex items-start gap-3">
                <span className="shrink-0 flex items-center justify-center w-6 h-6 rounded-full bg-primary mt-0.5">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} />
                </span>
                <span className="text-[15px] font-medium text-foreground">{p.text}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
